import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfinity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 13.1973C12 13.1973 9.75 8.69727 6.09375 8.69727C3.55687 8.69727 1.5 10.7129 1.5 13.1973C1.5 15.6816 3.55687 17.6973 6.09375 17.6973C7.85203 17.6973 9.42187 16.6468 10.5 15.4473",
			stroke: "#7683A8",
			strokeWidth: 1.49989,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9997 13.1973C11.9997 13.1973 14.2497 17.6973 17.9059 17.6973C20.4428 17.6973 22.4997 15.6816 22.4997 13.1973C22.4997 10.7129 20.4428 8.69727 17.9059 8.69727C16.1477 8.69727 14.5778 9.74773 13.4997 10.9473",
			stroke: "#7683A8",
			strokeWidth: 1.49989,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgInfinity);
export default ForwardRef;
